export default {

  header: {
    barColor: '#444',
    logoContainerColor: 'transparent',
    logoContainerWidth: 140,
    logo: false,
    logoWidth: '80%',
    logoHeight: undefined
  },

  headerButtons: {
    buttonColor: 'transparent',
    buttonColorActive: 'rgba(255,255,255,0.15)',
    buttonColorHovered: 'rgba(255,255,255,0.2)',
    buttonColorSelected: 'rgba(255,255,255,1)',
    textColor: 'rgba(255,255,255,0.85)',
    textColorActive: 'rgba(255,255,255,0.95)',
    textColorHovered: 'rgba(255,255,255,1)',
    textColorSelected: '#444',
    iconColor: 'rgba(255,255,255,0.85)',
    iconColorActive: 'rgba(255,255,255,0.95)',
    iconColorHovered: 'rgba(255,255,255,1)',
    iconColorSelected: '#444',
  },

  startup: {
    loadingIndicator: false
  },

  login: {
    brandingPanelColor: '#444',
    brandingPanelLogo: null,
    formPanelColor: '#FFF',
    headingColor: '#444',
    subheadingColor: '#555',
    labelTextColor: '#444',
    inputTextColor: '#666',
    inputBorderColor: '#CCC',
    inputBorderColorFocused: '#666',
    submitButtonColor: '#2993FC',
    submitButtonTextColor: '#FFF'
  }

}


